"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_bootstrap_1 = require("react-bootstrap");
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
const MalomoButton_1 = require("./MalomoButton");
const StyledFeatherIcon_1 = require("components/general/StyledFeatherIcon");
const ModalHeader = styled_components_1.default.h2 `
  font: Bold ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
`;
const SimpleModal = ({ body, display, header, hideButtons, onToggleModal, primaryButton }) => {
    function handleClick(event) {
        if (event.target.id === 'modal-root') {
            onToggleModal();
        }
    }
    return (react_1.default.createElement("div", { "aria-hidden": 'true', className: 'modal fade show', id: 'modal-root', onClick: handleClick, role: 'dialog', style: { display: display ? 'block' : 'none' }, tabIndex: -1 },
        react_1.default.createElement("div", { className: 'modal-dialog modal-dialog-centered modal-container', role: 'document' },
            react_1.default.createElement(react_bootstrap_1.Fade, { in: display },
                react_1.default.createElement("div", { className: 'modal-content' },
                    react_1.default.createElement(ModalHeader, { className: 'card-header', id: 'exampleModalCenterTitle' },
                        react_1.default.createElement("span", null, header),
                        react_1.default.createElement("button", { "aria-label": 'Close', className: 'close', "data-dismiss": 'modal', onClick: onToggleModal, type: 'button' },
                            react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { className: 'fe fe-x', color: config_1.colors.thundercloud }))),
                    react_1.default.createElement("div", { className: 'card-body' }, body),
                    hideButtons ? null : (react_1.default.createElement("div", { className: 'modal-footer', style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '0 16px 8px 16px',
                            borderTop: 'none'
                        } },
                        react_1.default.createElement(MalomoButton_1.MalomoButton, { onClick: onToggleModal, secondary: true }, "Cancel"),
                        primaryButton)))))));
};
SimpleModal.propTypes = {
    body: prop_types_1.default.node,
    display: prop_types_1.default.bool,
    header: prop_types_1.default.node,
    hideButtons: prop_types_1.default.bool,
    onToggleModal: prop_types_1.default.func,
    primaryButton: prop_types_1.default.element
};
exports.default = SimpleModal;
